import { FC } from "react";
import { Alert, Box, Grid2 as Grid } from "@mui/material";
import OccupationForm from "@components/OccupationForm/OccupationForm";
import { useFieldArray, UseFormReturn } from "react-hook-form";
import TextIconButton from "@components/TextIconButton";
import AddIcon from "@mui/icons-material/Add";
import { FamilyMemberFormType, PersonFormType } from "@utils/patientFormHelper";
import { useTranslation } from "react-i18next";

const OccupationsForm: FC<{ form: UseFormReturn<PersonFormType> }> = ({
  form,
}) => {
  const { t } = useTranslation();
  const { control } = form;
  const {
    fields: occupationFields,
    append: appendOccupation,
    remove: removeOccupation,
    update: updateOccupation,
  } = useFieldArray<FamilyMemberFormType, "occupations">({
    control,
    name: "occupations",
    keyName: "_id" as any,
  });

  const addOccupation = (): void => {
    appendOccupation({
      id: undefined,
      name: undefined,
      startDate: undefined,
      endDate: undefined,
    });
  };

  const deleteOccupation = (index: number): void => {
    const occupation = occupationFields[index];
    if (!occupation) {
      return;
    }
    if (!occupation.id) {
      removeOccupation(index);
    } else {
      updateOccupation(index, { ...occupation, delete: true });
    }
  };

  return (
    <>
      <Alert variant="standard" severity="info" color="info">
        {t("personForm.occupationsDescription")}
      </Alert>
      <Grid container spacing={2} marginTop="16px">
        <Grid size={12}>
          <Grid container spacing={{ xs: 5, md: 2 }}>
            {occupationFields.map((field, index) => {
              if (field.delete) {
                return "";
              }
              return (
                <Grid size={12} key={field._id}>
                  <OccupationForm
                    index={index}
                    form={form}
                    onDeleteRow={deleteOccupation}
                  />
                </Grid>
              );
            })}
          </Grid>
        </Grid>

        <Grid size={12}>
          <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
            <TextIconButton
              iconLeft={true}
              variant="outlined"
              text={t("personForm.addOccupationButton")}
              icon={AddIcon}
              color="primary"
              onClick={addOccupation}
            />
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default OccupationsForm;
